import {
  GET_EDGE_CONTROLLER_DETAILS,
  GET_EDGE_CONTROLLER_DETAILS_SUCCESS,
  GET_EDGE_CONTROLLER_DETAILS_FAILURE,
  SET_ACTIVE_TAB,
  SET_ACTIVE_EDGE_CONTROLLER,
  TOGGLE_SNACKBAR,
  TOGGLE_ERROR_SNACKBAR,
  TOGGLE_REINIT_FORM,
  UPDATE_EDGE_CONTROLLER,
  UPDATE_EDGE_CONTROLLER_SUCCESS,
  UPDATE_EDGE_CONTROLLER_FAILURE,
} from './actions';

const initialState = {
  currentEdgeController: null,
  edgeControllerData: null,
  loading: false,
  isFetching: false,
  error: null,
  activeTab: 'details',
  showSnackbar: false,
  showErrorSnackbar: false,
  reinitForm: false,
};

export default function demoEdgeControllerDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_EDGE_CONTROLLER_DETAILS:
    case UPDATE_EDGE_CONTROLLER:
      return {
        ...state,
        loading: true,
        isFetching: true,
        error: null,
      };

    case GET_EDGE_CONTROLLER_DETAILS_SUCCESS:
      return {
        ...state,
        edgeControllerData: action.payload,
        loading: false,
        isFetching: false,
        error: null,
      };

    case UPDATE_EDGE_CONTROLLER_SUCCESS:
      return {
        ...state,
        loading: false,
        isFetching: false,
        error: null,
      };

    case GET_EDGE_CONTROLLER_DETAILS_FAILURE:
    case UPDATE_EDGE_CONTROLLER_FAILURE:
      return {
        ...state,
        loading: false,
        isFetching: false,
        error: action.payload || action.error,
      };

    case SET_ACTIVE_EDGE_CONTROLLER:
      return {
        ...state,
        currentEdgeController: action.edgeController,
      };

    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    case TOGGLE_SNACKBAR:
      return {
        ...state,
        showSnackbar: action.flag,
      };

    case TOGGLE_ERROR_SNACKBAR:
      return {
        ...state,
        showErrorSnackbar: action.flag,
        error: action.error,
      };

    case TOGGLE_REINIT_FORM:
      return {
        ...state,
        reinitForm: action.flag,
      };

    default:
      return state;
  }
}
